import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./paginas/principal/home";
import Login from "./paginas/principal/login";
import CadCliente from "./paginas/cadastro/cliente";
import Footer from "./componente/footer";
import PrivateRoute from "./componente/PrivateRoute"; // novo componente

function App() {
  return (
    <>      
      <BrowserRouter>      
      <Routes>
        <Route path="/" element={<Login />}/>
        <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute> } />
                
        <Route path="/cadastro/cliente" element={<PrivateRoute><CadCliente /></PrivateRoute>} />                     
      </Routes>      
      </BrowserRouter>
      <Footer />
    </>
  );
}

export default App;
